<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">カルーセル</div>
    <div class="text-subtitle2">コンテナータイプ：カルーセルの設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.type"
        :options="typeList"
        class="col"
        disable
      >
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end">
        <div>代替テキスト<span class="text-brand-red">*</span></div>
        <div class="text-caption">altText</div>
      </div>
      <q-input
        outlined
        dense
        lazy-rules
        v-model="currentAltText"
        :rules="[(val) => (val && val.length > 0) || requiredRule.altText]"
        class="col"
      />
    </div>
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageCarousel } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:altText', 'update:validateValue'],
})
export default class Carousel extends Vue {
  @Prop()
  modelValue!: IFlexMessageCarousel

  @Prop()
  altText!: string

  @Prop()
  isAdmin!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get currentAltText() {
    return this.altText
  }

  set currentAltText(value: string) {
    this.$emit('update:altText', value)
  }

  get requiredRule() {
    return {
      altText: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.answer.alt_text'),
      }),
    }
  }

  get typeList() {
    return [
      {
        label: 'カルーセル',
        value: 'carousel',
      },
      {
        label: 'バブル',
        value: 'bubble',
      },
    ]
  }

  @Watch('currentAltText', { immediate: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
</script>

<style scoped lang="scss">

</style>
